import {useMutation} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {ReportResult} from "../../../../types/ReportResult";
import {ApiResult} from "../../../../types/ApiResult";

export const usePlaceOrder = (quoteID: number) => {

    const {mutateAsync, isLoading} = useMutation({
        mutationFn: async ({projectNumber}: { projectNumber: string }) => {
            return await apiClient.post('/estimate/place-order', {
                quoteID,
                projectNumber
            }) as ApiResult;
        }
    });

    return {
        mutateAsync, isLoading
    }
}
